import { render, staticRenderFns } from "./Ambulance.vue?vue&type=template&id=5a86dbd6&"
import script from "./Ambulance.vue?vue&type=script&lang=js&"
export * from "./Ambulance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports